<template>
    <div>
        <slot :events="events" :imageUrl="imageUrl" :formatEventDate="formatEventDate"></slot>
    </div>
</template>

<script>
import { defineComponent, onMounted, ref, inject } from 'vue';
import { has, isArray } from 'lodash';
import { getEvents } from '../services/inventory';
import { getCookie } from '../utils/cookie-handler'
import { fetch as fetchPolyfill } from 'whatwg-fetch';
import dateRange from '../utils/date-range';

const boDomain = window.AppConfig.boDomain.replace(/^\/|\/$/g, '');

export default defineComponent({
    name: 'WhatsOnFavorites',
    props: {

    },
    setup(props) {
        const events = ref([]);

        const imageUrl = inject('imageUrl');

        onMounted(async () => {
            events.value = await getEvents().then(response => {
                return response.filter(item => {
                    return (
                        has(item, 'tessitura.productionSeasonIds') &&
                        isArray(item.tessitura.productionSeasonIds) &&
                        item.tessitura.productionSeasonIds.length
                    );
                });
            });
        })

        const formatEventDate = function(event) {
            return dateRange(event.startDate, event.endDate);
        }

        return {
            events,
            imageUrl,
            formatEventDate
        }
    },
});
</script>
